module.exports = __webpack_public_path__ + "static/media/Copy of DJI_0042.18af0cb0.jpg";